import { makeAutoObservable } from 'mobx'
import { nanoid } from 'nanoid'
import {
  type IMergeFieldType,
  IntegrationKey,
  type IResponseMergeField,
} from 'entities/Integrations'
import type { ICustomFieldType } from 'entities/CustomField'
import { getCustomTypeByData } from 'entities/MergeField/lib/getCustomTypeByData'
import { toChatbotFieldType } from 'entities/MergeField/lib/toChatbotFieldType'

export class MergeField {
  id: string
  integrationId: number
  integrationKey: IntegrationKey
  label: string
  name: string
  photo_url: string
  template: string
  value: string
  type: IMergeFieldType
  groupName: string
  referencedObjectType?: string

  constructor(response: IResponseMergeField) {
    this.id = nanoid()
    this.integrationId = response.integrationId
    this.value = response.value || ''
    this.type = response.type || ''
    this.groupName = response.groupName || ''
    this.referencedObjectType = response.referencedObjectType || ''

    if (response.integrationKey) {
      this.integrationKey = response.integrationKey as IntegrationKey
      this.label = response.label || ''
      this.name = response.name || ''
      this.photo_url = response.photo_url || ''
      this.template = response.template || `{ ${this.integrationKey}.${this.name}`
    } else {
      this.integrationKey = IntegrationKey.salesmessage
      this.label = response.label || response.name || ''
      this.name = response.key || response.name || ''
      this.photo_url = ''
      this.template = `{ ${this.name} }`
    }

    makeAutoObservable(this)
  }

  get typeCustom(): ICustomFieldType {
    return getCustomTypeByData(this.type)
  }

  get typeChatbotField() {
    return toChatbotFieldType(this.type)
  }
}
